import findBobTheme from "./findbobTheme";
import manulifeTheme from "./manulifeTheme";
import rjTheme from "./rjTheme";
import ppiTheme from "./ppiTheme";
import demoTheme from "./demoTheme";


export default { findBobTheme, manulifeTheme, rjTheme, ppiTheme, demoTheme, }